import { Dialog, DialogTitle, DialogBody } from "V2.0/common/dialog";
import Joi from "joi-browser";
import Form from "V2.0/components/Form";
import { message } from "antd";
import { useState } from "react";
import { duplicateAssistant } from "./service";

const template = [
  { name: "name", label: "Assistant Name", type: "text" },
  {
    name: "description",
    label: "Description",
    type: "textArea",
    style: { height: "100px" },
    description: "Describe Who the assistant is?",
  },
];

const schema = {
  name: Joi.string().required(),
  description: Joi.string().allow(null, ""),
};

const buttonInfo = {
  buttons: "2",
  primaryLabel: "Duplicate",
  secondaryLabel: "Cancel",
};

function AssistantDuplicate(props) {
  const {
    isOpen,
    onClose,
    assistantId,
    assistantName,
    workspaceId,
    onSuccess,
  } = props;
  const [loading, setLoading] = useState(false);

  const assistantData = {
    name: "",
    description: "",
  };

  const handleDuplicate = async (data) => {
    setLoading(true);
    message.loading("Duplicating..");

    try {
      const response = await duplicateAssistant({
        workspaceId,
        assistantId,
        payload: data,
      });

      if (response.status === 200) {
        const assistant = response.data;
        message.destroy();
        message.success("Assistant duplicated");
        onSuccess(assistant._id);
        onClose();
      }
    } catch (e) {
      message.destroy();
      message.error(e.response.data?.msg || e.response.data?.message || e.response.data?.error || "Failed to duplicate assistant");
    }
  };

  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogTitle>Duplicate {assistantName}?</DialogTitle>
      <DialogBody>
        <Form
          inputField={assistantData}
          buttonInfo={buttonInfo}
          onSubmit={handleDuplicate}
          loading={loading}
          setLoading={setLoading}
          handleSecondary={onClose}
          template={template}
          schema={schema}
        />
      </DialogBody>
    </Dialog>
  );
}

export { AssistantDuplicate };
